import type * as Types from '../../graphql/types.d'

import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type AllCountriesQueryVariables = Types.Exact<{ [key: string]: never }>

export type AllCountriesQuery = { __typename?: 'Query' } & {
  countries: Array<
    { __typename?: 'Country' } & Pick<Types.Country, 'id' | 'name' | 'bounds' | 'slug'> & {
        continent: Types.Country['region']
      }
  >
}

export const AllCountriesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllCountries' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bounds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'continent' },
                  name: { kind: 'Name', value: 'region' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode
